import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

let cleanupTracks: (() => void) | null = null;

export const setTracksCleanup = (fn: () => void) => {
  cleanupTracks = fn;
};

declare global {
  interface Window {
    __amplimed_frontend__: {
      frontTelemedicina: {
        init: (options: {
          root: HTMLElement;
          props: { token: string; [key: string]: any };
        }) => void;
        destroy: () => void;
      };
    };
    frontTelemedicinaOptions: { [key: string]: any };
  }
}

let mountedRoot: HTMLElement | null = null;

const renderApp = (rootElement: HTMLElement) => {
  ReactDOM.render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
    rootElement
  );
  mountedRoot = rootElement;
};

const destroyApp = () => {
  if (mountedRoot) {
    ReactDOM.unmountComponentAtNode(mountedRoot);
    mountedRoot = null;
  }

  if (cleanupTracks) {
    cleanupTracks();
    cleanupTracks = null;
  }
};

if (!window.__amplimed_frontend__) {
  window.__amplimed_frontend__ = {} as any;
}

window.__amplimed_frontend__.frontTelemedicina = {
  init: ({ root, props }: { root: HTMLElement; props: { token: string; [key: string]: any } }) => {
    if (!root) {
      console.error("Elemento root não encontrado.");
      return;
    }

    window.frontTelemedicinaOptions = props;
    renderApp(root);
  },
  destroy: destroyApp
};

const rootElement = document.getElementById("root");
if (rootElement) {
  renderApp(rootElement);
}

export default window.__amplimed_frontend__;
